<template>
  <div class="root">
    <Slider
      v-if="!isArray"
      onLabel="Series"
      offLabel="Value"
      :on="!isNumber"
      @change="emitOppositeNewValue()"
    />

    <div v-if="isNumber">
      <input type="number" :value="value" @change="emitNewValue(+$event.target.value)"  />
      
    </div>
    <div v-else-if="isArray">
      <div v-for="(name, index) in value" :key="index">
        <BubbleText :text="name" @delete="emitArrayWithoutIndex(index)" />
      </div>

      <Selector
        @change="emitArrayWithValue($event)"
        :itemList="availableComponents"
        :selectedItem="''"
      />
    </div>
    <div v-else>
      <Selector
        @change="emitNewValue($event)"
        :itemList="availableComponents"
        :selectedItem="value"
      />
    </div>
  </div>
</template>

<script>
import Selector from '@/components/ui/Selector.vue';
import BubbleText from '@/components/ui/BubbleText.vue';
import Slider from '@/components/ui/Slider';

const _ = require('lodash');


export default {
  name: 'InputSelector',
  components: {
    Selector,
    BubbleText,
    Slider
  },
  props: {
    value: { default: ''},
    availableComponents: { type: Array, default: () => [] }
  },
  computed: {
    isNumber() {
      return this.value !== '' && !isNaN(this.value);
    },
    isArray() {
      return Array.isArray(this.value);
    }
  },
  methods: {
    emitNewValue(newVal) {
      this.$emit('newValue', newVal);
    },
    emitArrayWithoutIndex(indexToRemove) {
      let newValue = [
        ...this.value.slice(0, indexToRemove),
        ...this.value.slice(indexToRemove+1)
      ];
      this.emitNewValue(newValue);
    },
    emitArrayWithValue(valueToAdd) {
      let newValue = [
        ...this.value,
        valueToAdd
      ];
      this.emitNewValue(newValue);
    },
    emitOppositeNewValue() {
      if (this.isNumber) {
        this.emitNewValue('');
      } else {
        this.emitNewValue(0);
      }
    }
  },  
}
</script>

<style scoped>
.root {
  display: inherit;
  padding: 0 10px;
}
</style>